import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';
import SectionHeader from '@/components/section-header';

interface Props {
  title?: string;
  headerActions?: ReactNode;
  children: ReactNode;
}

const UserEventSection: FC<Props> = ({ title, headerActions, children }) => {
  return (
    <Box mb={2}>
      {title && (
        <Box mb={2}>
          <SectionHeader title={title} headerActions={headerActions} />
        </Box>
      )}
      {children}
    </Box>
  );
};

export default UserEventSection;
